import React, { useMemo } from "react";
import { FlipperVaultCardProps } from "../index";
import CheckedOutByOther from "./CheckedOutByOther";
import CheckedOutByMe from "./CheckedOutByMe";
// import Released from "./Released";
import ExpiredByOther from "./ExpiredByOther";
import { useFlipperState } from "../../../../hooks/custom/useFlipperState";
import CanCheckout from "./CanCheckout";
import AvatarFlipper from "../avatar";
import styles from "./index.module.scss";
import AddToCalling from "../../add-to-calling";
import { useSearchParams } from "react-router-dom";

interface BottomBarProps {
  isCooldownActive?: boolean;
  flipperData: FlipperVaultCardProps;
  userDetail: any;
  setIsExpired: (isExpired: boolean) => void;
  isExpired: boolean;
  setHideInfo: (hideInfo: boolean) => void;
  type?: string;
  showReleaseBtn: boolean;
  setShowReleaseBtn: any;
}

export default function FlipperBottomBar({
  isCooldownActive = false,
  flipperData,
  userDetail,
  setIsExpired,
  isExpired,
  setHideInfo,
  type,
  showReleaseBtn,
  setShowReleaseBtn
}: BottomBarProps) {
  const state = useFlipperState({
    flipperData,
    userId: userDetail?.id,
    isExpired
  });
  const [searchParams] = useSearchParams();
  const propertyId = searchParams.get("pid") || "";

  const renderState = useMemo(() => {
    switch (state) {
      case "checkedOutByOther":
        return (
          <CheckedOutByOther
            flipperData={flipperData}
            userDetail={userDetail}
            type={type}
            setIsExpired={setIsExpired}
          />
        );
      case "checkedOutByMe":
        return (
          <CheckedOutByMe
            // showReleaseBtn={showReleaseBtn}
            setShowReleaseBtn={setShowReleaseBtn}
            flipperData={flipperData}
            setIsExpired={setIsExpired}
            // type={type}
          />
        );
      // case "released":
      //   return (
      //     <Released
      //       flipperData={flipperData}
      //       userDetail={userDetail}
      //       type={type}
      //       setIsExpired={setIsExpired}
      //     />
      //   );
      case "OwnerAndReleasedByOther":
        return <ExpiredByOther flipperData={flipperData} type={type} />;
      case "OwnerAndReleasedByOwner":
        return (
          <div className={styles.AccountOwner}>
            <AvatarFlipper owner={flipperData?.owner} />
          </div>
        );
      case "canCheckout":
        return (
          <>
            <CanCheckout
              isCoolDownActive={isCooldownActive}
              acctId={flipperData.acctId}
              setHideInfo={setHideInfo}
              isExpired={isExpired}
              flipperData={flipperData}
              type={type}
            />
          </>
        );
      case "expiredByOther":
        return <ExpiredByOther flipperData={flipperData} type={type} />;
      case "locked":
      case "expiredByMe":
      default:
        return (
          <div className={styles.AccountOwner}>
            <AvatarFlipper owner={flipperData?.owner} />
            {!flipperData?.isInCallingPipeline && (
              <AddToCalling
                accountId={flipperData?.acctId}
                pubPropertyId={propertyId}
              />
            )}
          </div>
        );
    }
  }, [state, flipperData, userDetail, setIsExpired, setHideInfo, isExpired]);

  return renderState;
}
